export default __webpack_public_path__ + "static/media/thumb-lv.52513011.png";